<template>
  <div>
    <page-header title="Alunos Captação">
      <template #description>
        Alunos em fluxo de captação/parcelamento (ainda em processo de
        matrícula). Filtre por nome, CPF, status do plano de pagamento,
        instituição ou data e abra o caso pra revisar dados, documentos
        e proposta financeira.
      </template>
    </page-header>
    <div class="panel panel-default">
      <div class="panel-body">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label for="">Nome</label>
              <input
                v-model="filters.name"
                @keydown.enter="getStudents"
                type="text"
                class="form-control"
                placeholder="Nome"
              >
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label for="">CPF</label>
              <input
                v-model="filters.cpf"
                v-mask="'###.###.###-##'"
                @keydown.enter="getStudents"
                type="text"
                class="form-control"
                placeholder="CPF"
              >
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <label for="">Ativo</label>
              <select class="form-control" v-model="filters.active" @change="getStudents">
                <option value="">
                  Todos
                </option>
                <option :value="true">
                  Ativo
                </option>
                <option :value="false">
                  Desativado
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <label for="">Status</label>
              <select class="form-control" v-model="filters.payment_plan_status" @change="getStudents">
                <option value="">
                  Todos
                </option>
                <option v-for="(status, index) in statusOptions" :value="status.value" :key="index">
                  {{ status.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <label for="">Tipo do plano</label>
              <select class="form-control" v-model="filters.plan_type" @change="getStudents">
                <option value="">
                  Todos
                </option>
                <option value="installment">
                  Parcelamento
                </option>
                <option value="digital_enrollment">
                  Matrícula Digital
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 text-right">
            <button @click="getStudents" class="btn btn-primary" type="button">
              Pesquisar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row students-list">
      <div class="col-md-12">
        <div class="list-group">
          <div v-for="student in students" :key="student.id" class="row list-group-item">
            <div class="col-md-3">
              <router-link
                :to="{ name: 'parcelamento-student-details', params: { id: student.id } }"
                tag="div"
                class="students-list__link"
              >
                <div class="students-list__name">
                  <strong>{{ student.name }}</strong>
                </div>
                {{ student.cpf }}
              </router-link>
            </div>
            <div class="col-md-2">
              <router-link
                :to="{ name: 'parcelamento-student-details', params: { id: student.id } }"
                tag="div"
                class="students-list__link"
              >
                <span class="students-list__email-header">Email</span>
                <div class="students-list__email">
                  {{ student.email }}
                </div>
              </router-link>
            </div>
            <div class="col-md-2">
              <router-link
                :to="{ name: 'parcelamento-student-details', params: { id: student.id } }"
                tag="div"
                class="students-list__link"
              >
                <span class="students-list__cellphone-header">Status</span>
                <div class="students-list__cellphone">
                  {{ student.paymentPlan.translatedStatus }}
                </div>
              </router-link>
            </div>
            <div class="col-md-2">
              <router-link
                :to="{ name: 'parcelamento-student-details', params: { id: student.id } }"
                tag="div"
                class="students-list__link"
              >
                <span class="students-list__cellphone-header">Curso</span>
                <div>
                  {{ courseName(student) }}
                </div>
              </router-link>
            </div>
            <div class="col-md-2">
              <router-link
                :to="{ name: 'parcelamento-student-details', params: { id: student.id } }"
                tag="div"
                class="students-list__link"
              >
                <span class="students-list__plan-type-header">Tipo do plano</span>
                <div class="students-list__plan-type">
                  {{ student.paymentPlan.translatedPlanType }}
                </div>
              </router-link>
            </div>
            <div class="col-md-1 students-list__action-button">
              <par-update-active-button :student="student" @deactivate="deactivate" @activate="activate" />
            </div>
          </div>

          <br>

          <div v-if="totalPages">
            <pagination ref="pagination" :total-pages="totalPages" @page-changed="onPageChange" />
          </div>
        </div>
        <div v-if="students.length === 0">
          Nenhum aluno encontrado.
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  .students-list__link {
    cursor: pointer;
  }

  .students-list__action-button {
    align-items: center;
    display: flex;
    height: 50px;
    justify-content: center;
  }
</style>
<script>
import ParcelamentoService from 'services/ParcelamentoService';
import Pagination from 'components/Pagination';
import ParUpdateActiveButton from 'components/ParUpdateActiveButton';

export default {
  components: {
    Pagination,
    ParUpdateActiveButton,
  },
  data() {
    return {
      statusOptions: [
        { value: 'started', text: 'Cadastro realizado' },
        { value: 'offer_completed', text: 'Oferta selecionada' },
        { value: 'data_completed', text: 'Dados preenchidos' },
        { value: 'documents_in_analysis', text: 'Documentação em análise' },
        { value: 'documents_reproved', text: 'Documentação reprovada' },
        { value: 'documents_approved', text: 'Documentação aprovada' },
        { value: 'waiting_enrollment', text: 'Aguardando matrícula' },
        { value: 'approved', text: 'Aprovado' },
        { value: 'reproved', text: 'Reprovado' },
      ],
      students: [],
      totalPages: 0,
      filters: {
        active: true,
        name: '',
        cpf: '',
        payment_plan_status: '',
        plan_type: '',
        page: 1,
      },
    };
  },
  created() {
    this.getStudents();
  },
  methods: {
    onPageChange($event) {
      this.filters.page = $event;
      this.getStudents();
    },
    clearCpf(cpf) {
      if (!cpf) return null;
      return cpf.replace(/[. -]+/g, '');
    },
    deactivate($student) {
      this.$loader.show();
      ParcelamentoService.deactivateStudent($student.id)
        .then(() => {
          const student = this.students[this.students.indexOf($student)];
          student.active = false;
          this.$alert.notifySuccess('Aluno desativado com sucesso');
        })
        .catch(() => {
          this.$alert.notifyAlert('Falha ao desativar o aluno, contate os desenvolvedores do Parcelamento');
        })
        .finally(() => {
          this.$loader.hide();
        });
    },
    activate($student) {
      this.$loader.show();
      ParcelamentoService.activateStudent($student.id)
        .then(() => {
          const student = this.students[this.students.indexOf($student)];
          student.active = true;
          this.$alert.notifySuccess('Aluno ativado com sucesso');
        })
        .catch(() => {
          this.$alert.notifyAlert('Falha ao ativar o aluno, contate os desenvolvedores do Parcelamento');
        })
        .finally(() => {
          this.$loader.hide();
        });
    },
    getStudents($event) {
      if ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        this.filters.page = 1;
      }
      this.$loader.show();
      ParcelamentoService.getStudents({ ...this.filters, cpf: this.clearCpf(this.filters.cpf) })
        .then((body) => {
          this.students = body.list;
          this.totalPages = Math.ceil(body.totalCount / body.perPage);
        })
        .finally(() => {
          this.$loader.hide();
        });
    },
    isDigitalEnrollment(student) {
      return student.paymentPlan.planType === 'digital_enrollment';
    },
    courseName(student) {
      if (this.isDigitalEnrollment(student)) {
        return student.paymentPlan.course;
      }
      return student.paymentPlan.offer ? (
        `${student.paymentPlan.offer.course.name} (${student.paymentPlan.offer.course.level}) -
                       ${student.paymentPlan.offer.course.kind}`
      ) : '-';
    },
  },
};
</script>
